<main>
    <div class="partner-grid center-float">
        <div>Partner</div>
        <select class="select" id="partner-select" bind:value={partner_username} on:click={selectPartner}>
            {#each partners as partner}
                <option value={partner}>{partner}</option>
            {/each}
        </select>
        <button class="select-button" id="notes-chat" on:click={displayNotes}>Notes</button>
    </div>
    <input type="text" id="partner-system"
        bind:value={system_text}
        on:input={inputSystem}
        placeholder="system description"
    />
</main>

<style>
    #partner-system {
        width: 33vw;
        border-radius: 0.5vh;
    }
    .center-float {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .partner-grid {
        display: grid;
        grid-template-columns: auto auto auto;
        justify-items: start;
        gap: 1vw;
    }
</style>

<script>
    import { get } from 'svelte/store';
    import { user, state } from './data-store.js'
    import { buildMessage, assignPartnerData, textToSuit } from './common.js';
    import { elementDisplay, isUndefined, setHTML, setValue } from './utilities.js';
    import { writeToUser } from './user.js';

    var partner;
    let partner_username = '';
    let system_text = $user.partners[partner_username];
    $: partners = getPartners($user.partners);

    function getPartners(raw_partners) {
        let partners = [];
        if (!isUndefined(raw_partners)) {
            for (const [key, value] of Object.entries(raw_partners)) {
                partners.push(key);
            };
        };

        partners.sort();
        let user_store = get(user);
        if (partners.length && !partner_username) {
            partner_username = partners[0];
            if (user_store.last_partner) {
                partner = user_store.last_partner;
                partner_username = user_store.last_partner;
            }
            $user.partners[partner_username].username = partner_username;
            system_text = partner.system;
            get(state).partner = partner.name;
            get(state).system = partner.system;
        }
        if (!isUndefined(partner)) {
            selectPartner();
        }
        assignPartnerData(partners, partner_username)
        return partners;
    }

    function selectPartner() {
        partner = $user.partners[partner_username];
        system_text = partner.system;
        get(state).partner = partner.name;
        get(state).system = partner.system;
        elementDisplay('partners-notes', 'none')
        if (partner.notes) {
            setValue('partners-notes-text', partner.notes);
        }
        buildMessage();
        setPartnerValues(partner)
        let user_store = get(user);
        user_store.last_partner = partner_username;
        user.set(user_store)
        writeToUser()
    }

    function displayNotes() {
        elementDisplay('partners-notes', 'flex')
    }

    function setPartnerValues(partner) {
        setValue('partner-username', partner.username)
        setValue('partner-name-input', partner.name)
        setValue('system-input', partner.system)
        setValue('partners-notes-edit', partner.notes)
        // setValue('partners-chat-edit', partner.chat)
    }

    function inputSystem() {
        get(state).system = system_text;
        buildMessage();
    }
</script>
